"use client";
import React from "react";
import PageLayout from "@/layouts/pageLayout";
import PrivateCloudTabs from "@/components/pageTabs/privateCloudTabs";
import Faqs from "./components/faqs";
import Hero from "./components/hero";
import Intro from "./components/intro";
import ComparisonComponent from "./components/comparison";
import OnDemandCards from "./components/chooseOnDemand";
import FeaturesComp from "./components/features";

const ManagedUnmanagedCoManagedPage = () => {
  return (
    <PageLayout showContactForm spacing={16}>
      <Hero />
      <PrivateCloudTabs />
      <Intro />
      <FeaturesComp />
      <ComparisonComponent />
      <OnDemandCards />
      <Faqs />
    </PageLayout>
  );
};

export default ManagedUnmanagedCoManagedPage;
